
<template>
  <div class="expand-container" :class="{ 'expanded': isExpanded }" @click="toggleExpand"
    :style="{ maxHeight: expandHeight + 'px' }">
    <div class="header">
      <div class="header-icon">
        <i class="notranslate material-icons icon" aria-hidden="true" role="presentation">{{ icon }}</i>
      </div>
      <div class="header-label">
        {{ label }}
      </div>
      <div class="header-icon">
        <i class="notranslate material-icons icon expand-icon" aria-hidden="true"
          role="presentation">keyboard_arrow_down</i>
      </div>
    </div>
    <div class="expand-content" ref="expandContent">
      <slot></slot>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    label: [Number, String],
    icon: String,
  },
  data() {
    return {
      isExpanded: false,
      contentHeight: 0,
      expandHeight: 48, // Default height for the header
    }
  },
  methods: {
    toggleExpand(event) {
      let targetElement = event.target
      do {
        if (targetElement.nodeName === 'INPUT' || targetElement.nodeName === 'BUTTON'
        || targetElement.className ==='card-section') {
          // Ignore clicks on input elements
          return
        }
        targetElement = targetElement.parentNode
      } while (targetElement)

      this.isExpanded = !this.isExpanded
      // Adjust this to immediately set expandHeight for smoother animation
      this.adjustHeight()
    },
    adjustHeight() {
      // Use nextTick to ensure the DOM is updated
      this.$nextTick(() => {
        this.contentHeight = this.$refs.expandContent == null ? 0 : this.$refs.expandContent.scrollHeight //deleting last element
        this.expandHeight = this.isExpanded ? this.contentHeight + 48 : 48
      })
    }
  },
  mounted() {
    try {
      this.adjustHeight()
    } catch (error) {
      console.error('Error in mounted:', error)
    }

  },
  updated() {
    // Call adjustHeight on component update to accommodate content changes
    this.adjustHeight()
  }
}
</script>
<style lang="scss" scoped>
.expand-container {
  transition: max-height 0.3s;
  overflow: hidden;
}

.expand-icon {
  transition: transform 0.3s;
}

.expanded {
  .expand-icon {
    transform: rotate(180deg);
  }
}

.header {
  display: grid;
  grid-template-columns: 20px auto 20px;
  height: 48px;
  padding: 8px 16px;
  transition: color 0.3s, background-color 0.3s;

  &:hover {
    background-color: rgba(0, 0, 0, .07);
  }
}

.header-label,
.header-icon {
  align-self: center;
}

.header-label {
  padding-left: 32px;
}

.icon {
  font-size: 24px;
}
</style>
